$(() => {
  // Submit the form ONCE when the "onBfpDataLoad" event is emitted
  $(document).one('onBfpDataLoad', () => $("#idpForm").submit());
});
